var Buf = require('buf');


var Child = Buf.extend({
    initialize: function (data, options) {
        Buf.prototype.initialize.apply(this, arguments);
        this.threadCollapsedOverrides = {};
        this.threadExpandedOverrides = {};
    },
    messageHandlers: $.extend({}, Buf.prototype.messageHandlers, {
        delete_buffer: function (message) {
            this.removeFromConnection();
        }
    }),
    removeFromConnection: function () {
        this.connection.removeBuffer(this);
    },
    remove: function () {
        this.post('delete-buffer');
    },
    open: function () {
        this.say();
    },
    
    // Prefs
    prefKeys: $.extend({}, Buf.prototype.prefKeys, {
        'hideJoinPart': ['showJoinPart', true],
        'expandJoinPart': ['collapseJoinPart', true],
        'reply-collapse': ['reply-expand', false],
        'reply-quote': ['reply-noquote', false],
        'disableTypingStatus': ['enableTypingStatus', true]
    }),
    setShowingJoinPartPref: function (enable) {
        this.setOverridePref(enable, 'hideJoinPart');
    },
    setCollapsingJoinPartPref: function (enable) {
        this.setOverridePref(enable, 'expandJoinPart');
    },
    setCollapsingRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-collapse');
    },
    setQuoteRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-quote');
    },
    setTypingStatusPref: function (enable) {
        this.setOverridePref(enable, 'disableTypingStatus');
    },
    isShowingJoinPart: function () {
        return this.checkPref('hideJoinPart');
    },
    isCollapsingJoinPart: function () {
        return this.checkPref('expandJoinPart');
    },
    isSharingTyping: function () {
        return this.checkPref('disableTypingStatus');
    },
    isCollapsingReplies: function () {
        return this.connection.isCollapsingReplies() || this.checkPref('reply-collapse');
    },
    isShowingQuoteReplies: function () {
        return this.connection.isShowingQuoteReplies() || this.checkPref('reply-quote');
    },
    isThreadCollapsed: function (msgId) {
        if (this.isCollapsingReplies()) {
            return !this.isThreadExpandedOverride(msgId);
        } else {
            return this.isThreadCollapsedOverride(msgId);
        }
    },
    isThreadCollapsedOverride: function (msgId) {
        return !!this.threadCollapsedOverrides[msgId];
    },
    isThreadExpandedOverride: function (msgId) {
        return !!this.threadExpandedOverrides[msgId];
    },
    setThreadCollapsedOverride: function (msgId, value) {
        delete this.threadExpandedOverrides[msgId];
        this.threadCollapsedOverrides[msgId] = value;
    },
    setThreadExpandedOverride: function (msgId, value) {
        delete this.threadCollapsedOverrides[msgId];
        this.threadExpandedOverrides[msgId] = value;
    }
});


module.exports = Child;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/child.js
// module id = MN+i
// module chunks = 1